// Quotation Internal Review Stage related codes goes here

// NPM Imports
import React, { Fragment } from "react";

// Components Imports
import { QuotationInternalReviewBtns } from "../QuotationTopBarBtns";

// Declarations

export default function QuotationInternalReviewStage(props) {
  return (
    <Fragment>
      <div className="document-meta">
        <div
          data-test="quotationtopbarbtns-document-meta"
          className="document-btns">
          <QuotationInternalReviewBtns {...props} />
        </div>
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationStages/QuotationInternalReviewStage.js